// Previous/next buttons for a horizontally scrolling row in rich content. `<div data-rem-scroller>` wraps the row (its
// first element child, scrolling with overflow-x); the script adds two real buttons that scroll the row by one item,
// disabled at the ends and hidden while everything fits. Labels: `data-rem-scroller-prev` / `-next`, else Hungarian,
// or English on an English page. Without the script the row stays an ordinary scrolling row.

// One step: the distance between the first two items (their gap included), else the width of the row.
export const stepSize = (offsets, visibleWidth) => (offsets.length > 1 ? offsets[1] - offsets[0] : visibleWidth);

export const atStart = (scrollLeft) => scrollLeft <= 1;

export const atEnd = (scrollLeft, clientWidth, scrollWidth) => scrollLeft + clientWidth >= scrollWidth - 1;

export const scrolls = (clientWidth, scrollWidth) => scrollWidth > clientWidth + 1;

const labelsFor = (holder) => {
    const english = (document.documentElement.lang || '').toLowerCase().startsWith('en');

    return {
        prev: holder.dataset.remScrollerPrev || (english ? 'Previous' : 'Előző'),
        next: holder.dataset.remScrollerNext || (english ? 'Next' : 'Következő'),
    };
};

const chevron = (direction) => {
    const points = direction === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';

    return `<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><polyline points="${points}" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
};

const button = (direction, label) => {
    const element = document.createElement('button');
    element.type = 'button';
    element.className = 'rem-scroller__button rem-scroller__button--' + direction;
    element.setAttribute('aria-label', label);
    element.innerHTML = chevron(direction);

    return element;
};

export const initScrollers = (root) => {
    root.querySelectorAll('[data-rem-scroller]').forEach((holder) => {
        const row = holder.firstElementChild;
        if (!row || holder.dataset.remScrollerBound === '1') {
            return;
        }
        holder.dataset.remScrollerBound = '1';
        const labels = labelsFor(holder);
        const controls = document.createElement('div');
        controls.className = 'rem-scroller__controls';
        const prev = button('prev', labels.prev);
        const next = button('next', labels.next);
        controls.append(prev, next);
        holder.append(controls);

        const update = () => {
            controls.hidden = !scrolls(row.clientWidth, row.scrollWidth);
            prev.disabled = atStart(row.scrollLeft);
            next.disabled = atEnd(row.scrollLeft, row.clientWidth, row.scrollWidth);
        };
        const move = (direction) => {
            const offsets = Array.from(row.children).slice(0, 2).map((item) => item.offsetLeft);
            const reduced = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            row.scrollBy({ left: direction * stepSize(offsets, row.clientWidth), behavior: reduced ? 'auto' : 'smooth' });
        };
        prev.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        row.addEventListener('scroll', update, { passive: true });
        if (typeof ResizeObserver === 'function') {
            new ResizeObserver(update).observe(row);
        } else {
            window.addEventListener('resize', update);
        }
        update();
    });
};
